import React from 'react';
import PropTypes from 'prop-types';
import { instanceOf } from 'prop-types';
import {message} from 'antd';
import s from './Login.css';
import Icon from '../../components/Icon/Icon';
import history from '../../history';
import {Link} from 'react-router-dom';
import {userTypes} from '../../UserTypes'
import {fetchDecode} from '../../fetchUtils';
import {withCookies, Cookies} from 'react-cookie';

class Login extends React.Component {

    static propTypes = {
        locale: PropTypes.objectOf(PropTypes.string).isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            login: '',
            password: '',
            userNameError: false,
            userNameLoginError: '',
            config: require('Config'),
            otp: '',
        };
        this.loginChange = this.loginChange.bind(this);
        this.passwordChange = this.passwordChange.bind(this);
        this.login = this.login.bind(this);
    }

    loginChange(event) {
        this.setState({login: event.target.value});
    }

    passwordChange(event) {
        this.setState({password: event.target.value});
    }

    successMessage = () => {
        message.success('Successfully logged in', 2);
    };

    errorMessage = (error) => {
        message.error(`An error has occurred: ${error}`, 5);
    };


    login = (e) => {
        e.preventDefault();
        var self = this;
        sessionStorage.setItem('username', this.state.login);
        fetch(this.state.config.serverUrl + "login/createsession",
            {
                method: 'POST',
                body: JSON.stringify({l: this.state.login, p: this.state.password}),
                headers: new Headers({
                    'Content-Type': 'application/json'
                })
            })
            .then((response) => {
                    if (response.status == 200) {
                        response.json().then(function (jsonResponse) {
                            let expiryDate = new Date();
                            expiryDate.setDate(expiryDate.getDate() + 1);
                            sessionStorage.setItem('authenticationtoken', jsonResponse.token);
                            self.props.cookies.set('authenticationtoken', jsonResponse.token, {expires:expiryDate, path: "/", domain:self.state.config.domain });
                            fetchDecode(self.state.config.serverUrl + `login/accountinfo`).then((response) => {
                                sessionStorage.setItem('senders_list', JSON.stringify(response.from_addresses));
                                sessionStorage.setItem('default_sender', response.default_anr);
                                sessionStorage.setItem('userType', userTypes.Fyrirtaeki)

                                self.props.cookies.set('username', response.username, {expires:expiryDate, path: "/", domain:self.state.config.domain });
                                self.props.cookies.set('senders_list', JSON.stringify(response.from_addresses), {expires:expiryDate, path: "/", domain:self.state.config.domain });
                                self.props.cookies.set('default_sender', response.default_anr, {expires:expiryDate, path: "/", domain:self.state.config.domain });
                                self.props.cookies.set('userType', userTypes.Fyrirtaeki, {expires:expiryDate, path: "/", domain:self.state.config.domain });

                                history.push("/");
                            });
                        });
                    }
                    else if (response.status >= 400 && response.status < 500) {
                        self.state.userNameLoginError = 'Rangt notandanafn eða lykilorð';
                        self.setState({userNameError: true});
                    }
                    else {
                        self.state.userNameLoginError = 'Ekki náðist samband við bakenda';
                        self.setState({userNameError: true});
                    }
                }
            )
            .catch((error) => {
                self.state.userNameLoginError = 'Ekki náðist samband við bakenda';
                self.errorMessage(error);
                self.setState({userNameError: true});
            });
    };

    render() {
        var link = <a href="mailto:radgjof@siminn.is" target="_blank">{this.props.locale.company}</a>
        return (
            <div className={s.root} >
                    <div className={s.wrapper}  className={s.border_box}>
                        {this.state.userNameError ?
                            <div className={s.warning}>
                                <div className={s.title}>{this.state.userNameLoginError}</div>
                                <div className={s.text}>{this.props.locale.errorContact}</div>
                            </div>
                            : ''}
                        <div className={s.content_form}>
                            <a href="/" className={s.logo}>
                                <Icon icon="logo"/>
                                <span>{this.props.locale.premiumHeader}</span>
                            </a>
                            <form onSubmit={this.login}>
                                <span className={s.name}>{this.props.locale.username}</span>
                                <input
                                    type="text"
                                    className={this.state.error ? s.input_error : s.input}
                                    onChange={this.loginChange}
                                />
                                <span className={s.name}>{this.props.locale.password}</span>
                                <input
                                    type="password"
                                    className={this.state.error ? s.input_error : s.input}
                                    onChange={this.passwordChange}
                                />
                                <input type="submit" value={this.props.locale.signIn} className={s.submit_btn}/>
                                <div className={s.textChange2}>{this.props.locale.contact} {link} {this.props.locale.contactFrh}</div>
                                <div className={s.textChange}>{this.props.locale.SMSWarning}</div>
                            </form>
                        </div>
                    </div>
            </div>
        )
    }
}

export default withCookies(Login);



// WEBPACK FOOTER //
// ./src/routes/login/Login.js